import React from 'react'
import { ParticipantsList } from './list/page'

export const GoldenMay2025ParticipantsPage = () => {
  return <ParticipantsList />
}
